import { render, staticRenderFns } from "./created.vue?vue&type=template&id=0179bcc4&scoped=true"
import script from "./created.vue?vue&type=script&lang=js"
export * from "./created.vue?vue&type=script&lang=js"
import style0 from "./created.vue?vue&type=style&index=0&id=0179bcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179bcc4",
  null
  
)

export default component.exports